module.exports = __webpack_public_path__ + "img/Steor-Icons-18.f9a680d6.svg";